export default __webpack_public_path__ + "img/b2bb8a740a81ce5057057ed8c0032b14.svg";